$(function () {

    var Main = {

        run: function () {
            //this.footerMove();
            initFilerOptions();
            $(".select2-target").select2();
            $("#filer_input").filer(filleroptions);
            $(".fancy-image").fancybox();
            $(".images-galery").owlCarousel({
                margin:10,
                navs:true,
                navRewind: true,
                dots: false
            });
            $(".tel-mask").inputmask({
                "mask": "+7 (999) 999-9999"
            });
            this.footerMove();
        },
        resizeFunctions: function () {
            this.footerMove();
        },
        scrollFunctions: function () {

        },
        footerMove: function () {
            var ua = navigator.userAgent.toLowerCase();
            var isOpera = (ua.indexOf('opera') > -1);
            var isIE = (!isOpera && ua.indexOf('msie') > -1);
            var viewportHeight = getViewportHeight();
            var wrapper = $("main");
            var footer = $("footer");

            function getViewportHeight() {
                return ((document.compatMode || isIE) && !isOpera)
                    ? (document.compatMode == 'CSS1Compat') ? document.documentElement.clientHeight : document.body.clientHeight : (document.parentWindow || document.defaultView).innerHeight;
            }

            wrapper.css("min-height", viewportHeight - footer.outerHeight(true));
        },
    };
    window.Application.addComponent("Main", Main);
});



